var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFalconreact2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 387.6 427.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #161619;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-5, .cls-6, .cls-7, .cls-15, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-3, .cls-5, .cls-15, .cls-12, .cls-13, .cls-14 {\n        stroke: #101013;\n      }\n\n      .cls-2, .cls-16 {\n        fill: #aeadae;\n        stroke: #aeadae;\n      }\n\n      .cls-3, .cls-9 {\n        fill: #121214;\n      }\n\n      .cls-4, .cls-17, .cls-18, .cls-19, .cls-20, .cls-16 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4, .cls-19 {\n        fill: #6d7a9c;\n        stroke: #6d7a9c;\n      }\n\n      .cls-5, .cls-21, .cls-10, .cls-11 {\n        fill: #e9e9e9;\n      }\n\n      .cls-17, .cls-8 {\n        fill: #292d3f;\n        stroke: #292d3f;\n      }\n\n      .cls-6 {\n        fill: #5c5c5c;\n        stroke: #5c5c5c;\n      }\n\n      .cls-21 {\n        stroke-width: 0px;\n      }\n\n      .cls-18 {\n        fill: #40403f;\n        stroke: #404040;\n      }\n\n      .cls-7 {\n        fill: #4c4b4c;\n        stroke: #4c4b4c;\n      }\n\n      .cls-15 {\n        stroke-width: 4px;\n      }\n\n      .cls-15, .cls-12 {\n        fill: none;\n      }\n\n      .cls-20 {\n        fill: #2d2d2d;\n        stroke: #2d2d2c;\n      }\n\n      .cls-9, .cls-11 {\n        stroke: #121214;\n      }\n\n      .cls-10 {\n        stroke: #e9e9e9;\n      }\n\n      .cls-13 {\n        fill: #101013;\n      }\n\n      .cls-14 {\n        fill: #171719;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arms_Colours-4",
    "data-name": "Arms Colours-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M311,272.9l-20.8,77.6-1.4,70h-69.9l2.3-94.1,36.3-71s17.2,6.2,27.5,3.5c0,0,11.6,12.6,15.3,13.4s12.3.6,12.3.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "320.3 260.3 314.9 271.5 300.7 268.7 287.6 256 262.8 255.4 269 244.7 291.6 245.4 305.8 257.6 320.3 260.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M82.8,272.9l20.8,77.6,1.4,70h69.9l-2.3-94.1-36.3-71s-17.2,6.2-27.6,3.5c0,0-11.6,12.6-15.3,13.4s-12.3.6-12.3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M76.7,272.9l6.6,1.8s35.7,41.7,22.2,70.7-11.1.2-11.1.2c0,0-19.2-18.7-19-23.5s.5-.1-2.4-3.9c-2-2.6-1.2-10-1.2-10l5-35.4h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "73.4 260.3 78.9 271.5 93 268.7 106.2 256 131 255.4 124.8 244.7 102.2 245.4 87.9 257.6 73.4 260.3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Arms_Lines-4",
    "data-name": "Arms Lines-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M315.5,263.4c0-3.5-5-4.5-7.5-4.5s-5.8,1.9-5.8,5.1,3.3,3.5,6.6,3.5,6.6-1,6.6-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M261.1,256.8s20-1,24.8.8,10.2,10.2,12.6,12.2,15.4,2.5,16.9,2.5,6.5-12.5,6.5-12.5c-.6-2.9-13.1-1.2-15.7-3s-8.6-9.3-13.1-12.1-25.9-1.6-25.9-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M312.7,272.9s1.1,18.5-1.4,30c-1.2,5.5-7.8,18.4-8.1,20-1,5.1-11.4,22.8-11.6,31.3s-1.4,54.1-1.4,54.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78.3,263.4c0-3.5,5-4.5,7.4-4.5s5.8,1.9,5.8,5.1-3.3,3.5-6.6,3.5-6.6-1-6.6-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M126.5,243.1s-21.5-1.2-25.9,1.6-10.5,10.3-13.1,12.1c-2.6,1.8-15.1,0-15.7,3,0,0,5,12.5,6.5,12.5s14.4-.5,16.9-2.5,7.9-10.4,12.6-12.2,24.8-.8,24.8-.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M68.1,316s1.2-5.7,4.4-14.9c0,0,3.5-25.8,3.5-31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M102.2,354.2c.2,8.5,1.3,60.3,1.3,60.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M95.2,269.8s8.9-2.3,14.1,11.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M100,348.4c-17-13.5-12.5-22.8-12.5-22.8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Main_Colours-4",
    "data-name": "Main Colours-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "248.4 140.7 196.9 146.9 145.4 140.7 128 151.9 157.8 247.6 183.1 331.5 196.9 327.5 210.6 331.5 235.9 247.6 265.8 151.9 248.4 140.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M248.7,95.1l-51.8-2.3h0l-51.8,2.3s-52.7,16.5-52.2,25.9,24.5,21,60.4,22.4c28.8,1.1,39.8,2.7,43.1,3.3v.2s.2,0,.6-.1c.4,0,.6.1.6.1v-.2c3.2-.6,14.3-2.2,43.1-3.3,35.9-1.4,60-13,60.4-22.4.4-9.4-52.2-25.9-52.2-25.9h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M196.9,419.6s21.1,26.7,20.1-27.5c-.4-20.3-1.6-84.3-1.6-84.3l-18.6,21.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M303.6,159.7l-36.4,63s.7,6.2-2.7,20.2c-3.4,13.9-10.5,14.9-10.5,14.9l-35.5,80.9-4.4-93.9,20.2-5.4-3.7-54.5c-.2-1.5,61.6-11.9,73-25.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M265.3,140.7s40.5,6.1,39.7,13.6c-.7,7.5-52.8,22-52.8,22,0,0,11.9-9.9,10.2-20.5s-5.9-12.2-5.9-12.2l8.8-3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 241.1,
    y1: 176.3,
    x2: 240.5,
    y2: 179.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.8,207.8l6.6-11.9c1.9,6.2,1.3,37.1,1.2,41l-7.1,2.4-.7-31.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M255.7,155.9s-1.1,12.8-8.5,16c0,0,4.8-5.4,4.9-7.7s-1.8-6.2-.7-7.8,1.6-4.3,1.6-4.3l2.7,3.9h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M197.5,108.8c18.7-.5,48.7-12.8,48.7-12.8,0,0-11.2-40.3-12.2-43.8s-8.6-7.3-17.3-4.4-19.8,4.4-19.8,4.4c0,0-11.1-1.6-19.8-4.4-8.7-2.9-16.3,1-17.3,4.4s-12.2,43.8-12.2,43.8c0,0,30,12.3,48.7,12.8h0c.2,0,.4,0,.6,0,.2,0,.4,0,.6,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M196.9,419.6s-21.1,26.7-20.1-27.5c.4-20.3,1.6-84.3,1.6-84.3l18.6,21.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M90.2,159.7l36.4,63s-.7,6.2,2.7,20.2c3.4,13.9,10.5,14.9,10.5,14.9l35.5,80.9,4.4-93.9-20.2-5.4,3.7-54.5c.2-1.5-61.6-11.9-73-25.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.5,140.7s-40.4,6.1-39.7,13.6c.7,7.5,52.8,22,52.8,22,0,0-11.9-9.9-10.2-20.5s5.9-12.2,5.9-12.2l-8.8-3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 152.6,
    y1: 176.3,
    x2: 153.2,
    y2: 179.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171,207.8l-6.6-11.9c-1.9,6.2-1.3,37.1-1.2,41l7.1,2.4.7-31.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M251.4,112.7l-4.4-13.1s-7.5,3.4-18.2,7c-9.7,3.2-28.4,4.8-31.9,5.1-3.5-.3-22.2-1.8-31.9-5.1-10.7-3.6-18.2-7-18.2-7l-4.4,13.1s29.2,16.9,54.5,15.7c25.2,1.2,54.5-15.7,54.5-15.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M138,155.9s1.1,12.8,8.5,16c0,0-4.8-5.4-4.9-7.7s1.8-6.2.7-7.8-1.6-4.3-1.6-4.3l-2.7,3.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M205.1,174.6c-1-.9-8.2,1-8.2,1,0,0-7.2-1.9-8.2-1-1,.9-1.1,3-.8,3.9.2.6,6.3,1.4,9,1.5,2.7-.2,8.8-.9,9-1.5.3-.9.2-3-.8-3.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M201,164.8s2.8,6.5,1.5,8.4-2.9,2.6-2.9,2.6l5.4,2.1s5.1-.7,4.9-2.3-1.7-10.4-1.7-10.4l-7.1-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.2,171.5s-6.8,16.7-7.2,30.7-14.5,21.4-14.5,21.4c0,0-12.6.4-17.1-6.6-1.3-13.7,2.2-20.8,6.9-26.3l-22.8-6.7,5.6,20v34l10.2,4.9-5.5,62.2,16.3,12,9.4-49.6,2-5-5.2-4.3-8.2-2.1.7-21.4s8.2,8.2,12.6,6.3,6.8-5,6.8-5l2.6,5.9,7-2.7-1.6-30.7,10.9-23.9,6-2.8,1.1-9.6-15.9-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167.1,188.6s15.6-40.6,56.3-15.5c10.7,6.6,15.6,1.9,15.6,1.9l9.2-31.4s-48.8,4.7-59.9,4.4-62.1-3.8-62.1-3.8c-9.2,1.5-7.7,47.4,40.9,44.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M177.9,46.5s9.2,13.8,18.8,13.3,14.6-5,14.6-5c0,0-1.1,4.5-.6,6.3s7.5,13.3,7,20.1,3.6,25.9,3.6,25.9l24.8-11.3s-10.1-44.8-14.3-46.5-9.4-3.6-9.4-3.6c0,0-16.7,8-25.6,8s-18.8-7.1-18.8-7.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M229,124.3s55-3.3,63.5,6.4c0,0,13-8.3,8.9-11.4s-12.8-13.3-28.6-16.7-23.3-5.6-23.3-5.6l2.5,16.9s-16.2,10.8-23.1,10.5h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "221.2 107.9 226.1 124.8 250.9 112.6 246.7 98.7 221.2 107.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M195.1,328.2s-6.7,59.9-4.9,75.4c1.9,15.5-11.9,1.4-11.9,1.4,0,0-5.6-73.2-1.6-99.8l18.3,23.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M287,161.4s-10.5,27.2-14.1,34.5-19.5,22.4-19.5,32.4,5.7,10,6.2,16c.4,4.4-3.3,16.5-5.2,22.3,0,0,13.8-30.8,14.2-40.9s18.3-37.1,18.3-37.1l15.3-29.9-15.3,2.7h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Main_Lines-4",
    "data-name": "Main Lines-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M196.9,224.8c6.7,0,19.6-11.2,26.6-19.8,0,0,4.8-8.1,7.1-15.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M248.7,145.2s-3.1,16.9-11.3,35.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M248.7,147.4s6.1-4.9,9-.4c2.9,4.5,3.5,12.7.6,18.7s-14.2,21-17.7,8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M255.7,155.4s-.3-4.9-2-4.9-5.3,6.2-4.1,9.2,2.4,4.4,1.4,6.2-4.1,3.3-4.9,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M203.6,177.8s-1.4-.5-2.8-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M248.7,95.1s54,10.9,54,25.1c0,21.9-80.1,26.7-105.8,26.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M196.9,128.9c34.4,0,55.3-15.5,55.3-15.5l-16.1-60.1c-1.6-5.2-10.7-9.8-15.3-8.7-5.4,1.4-13.2,6.8-24,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M196.9,110.4c26.5,0,49.3-12.6,49.3-12.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M217,400.9c5.8-67.4-5-157.6-5-157.6,4.9-2.5,19.3-4.9,19.3-4.9-1-22.5-.7-53.6-.7-53.6,0,0,75.7-18.5,75.7-29.8s-41-14.4-41-14.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M222.8,333.6s25.9-61,37.4-76.4c11.4-15.4,8.8-31.1,10.8-36.3s35.4-65,35.4-65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M171.6,207.8s.3,21.6,0,31.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M196.9,256.8c6.1.1,15.2-6.7,15.2-6.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M215.4,282.3c-8.3-7.5-9.1-29.2-18.1-24.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 217,
    y1: 305.1,
    x2: 207.6,
    y2: 316.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.9,187.3s3,2.2,8.1,2.5,20.3,4.4,20.3,4.4l-7-2.8c-10.7-4.5-13.6-9.9-21.4-7.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M196.9,192.1s7.4-.6,11.4-.9c3.2-.2,8.9,2.2,9.8,7.2,1.4,7.7-14.4,1.4-21.1,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M216.8,198.4s-5.5-1.7-8.8-1.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M196.9,224.8c-6.7,0-19.6-11.2-26.6-19.8,0,0-4.8-8.1-7.1-15.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M145.1,145.2s3.1,16.9,11.3,35.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M145.1,147.4s-6.1-4.9-9-.4-3.5,12.7-.6,18.7c2.9,6,14.2,21,17.7,8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M138,155.4s.3-4.9,2-4.9,5.3,6.2,4.1,9.2-2.4,4.4-1.4,6.2,4.1,3.3,4.9,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M190.2,177.8s1.4-.5,2.8-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M145.1,95.1s-54,10.9-54,25.1c0,21.9,80.1,26.7,105.8,26.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M196.9,128.9c-34.4,0-55.3-15.5-55.3-15.5l16.1-60.1c1.6-5.2,10.7-9.8,15.3-8.7,5.4,1.4,13.2,6.8,24,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M196.9,110.4c-26.5,0-49.3-12.6-49.3-12.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M176.7,400.9c-5.8-67.4,5-157.6,5-157.6-4.9-2.5-19.3-4.9-19.3-4.9,1-22.5.7-53.6.7-53.6,0,0-75.7-18.5-75.7-29.8s41-14.4,41-14.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M171,333.6s-25.9-61-37.3-76.4c-11.4-15.4-8.8-31.1-10.8-36.3s-35.4-65-35.4-65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M222.2,207.8s-.3,21.6,0,31.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M196.9,256.8c-6.1.1-15.2-6.7-15.2-6.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M178.3,282.3c8.3-7.5,9.1-29.2,18.1-24.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M205.7,272.9c.2-1.3,1.9-2.5,1.9-2.5l-2.3-8s-2,.6-2.6,1-5.8.4-5.8.4c0,0-5.1,0-5.8-.4-.6-.4-2.6-1-2.6-1l-2.3,8s1.8,1.2,1.9,2.5,3.2,11.8,3.2,11.8l-5.1,31.4,10.8,14.6,10.8-14.6-5.1-31.4s3-10.6,3.2-11.8Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 176.7,
    y1: 305.1,
    x2: 186.1,
    y2: 316.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.9,187.3s-3,2.2-8.1,2.5-20.3,4.4-20.3,4.4l7-2.8c10.7-4.5,13.6-9.9,21.4-7.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M196.9,192.1s-7.4-.6-11.4-.9c-3.2-.2-8.9,2.2-9.8,7.2-1.4,7.7,14.4,1.4,21.1,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M177,198.4s5.5-1.7,8.8-1.7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7-2",
    "data-name": "Layer 7-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M123.7,297.7l-20.9,25.6s2.6,22.2,1.9,23.6,23.9,31,23.9,31l22.7,5.5,29.8-2.8,10.9-11-7.1-49.5s-12-3.3-11-20.2c.3-5.4-1.6-8.4-10-11.4-10.6-3.9-33.2,1.2-33.2,1.2l-6.9,8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M80.1,305.1l-10.4,11s-1.7,21,0,24.9,13.9,10.6,13.9,10.6c0,0,11.6,18.9,14.7,21.6s12.7,13.8,12.7,13.8c0,0-9.4-14.7-8.1-18.8s5.2-42.1,5.2-42.1l1.5-5.5-.7-7,8.3-11.9-8.4-1.7-9.2-5.7s-14.2,5-19.5,10.6h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M188.2,326.2s-1,4.4.8,8-1.9,7,1,10.9,2.4,10.3,3.5,18.3c3.3,23.5-10.4,45.8-10.4,45.8l28.5-12.9,59.3-42.4,31.4-44.5s10.1-16.2,6.9-20.5-16-22.8-21.1-23.4-19.6-2.1-22.3,2.5-27.9,34.8-27.9,34.8l-3.2.2s-15.3,7.1-22.4,10-10.3,3.7-10.3,3.7l-15.1,5.5,1.2,4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.7,299.2s3.8,3.9,3.6,7.1-1.2,8.2-6.8,9.4c8.1,4.2,5.7,15.7,2.1,18-2.4,1.5-2.1,19.2-2.1,19.2l5.6,5.2-.7-16.7,3.8-3.2-3.1-7.9,14.1-11.3,16.7-6.1,21,1-4.8-22.1-6.1-8.4-43.4,7.9v8h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.3,341.3c4.7,8.5,29-2,29-2,.6-1.3,20.3.3,23.5.9s9.8,2.1,10-.9.5,11.1.5,11.1l1.7,17.7c-2.5,2.9-9,2.5-9,4.2s-26.1,9.4-26.1,9.4l-26.4-10.4,2.1-8.2-4.6-5.1s26,5.7,29.7,5.1,17-7.8,16.4-9.7-19.1.6-19.1.6l-23-2.4-4.7-10.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.9,328.8s1.1,2.3,4.3,2.7,23.6-7.9,23.6-7.9c0,0,21.1,2.5,24.4,1s-.4,4.5-2.2,5.2-22.1-1-22.1-1c0,0-21.8,8.5-25.3,7.1s-4.3-5.6-4.3-5.6l1.8-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.7,199.8l26.3,89.6s30.7,2.3,37.2.4,9.1-3.4,9.1-3.4l9.2-93.9-19.8-23.3s-37.5-.5-45.5,4-16.5,26.6-16.5,26.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.5,150.9l-2.3,19.6h20.4l-6-19.6s-10.3-3.3-12.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M130.1,293.6l4.6,19.2s12.4,6.8,17.6.7,2.9-23.6,2.9-23.6l-25.1,3.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M165.8,178.7s-5.5,99.6-12.1,103.6-23.1,8.6-23.1,8.6c0,0,31-.4,33.7-4.5,1.7-2.6,6-37.7,8.2-64.5,1.2-15.2,1.1-29.3,1.1-29.3l-7.8-13.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M106.9,345.2s-2.8,18.3-1.3,23.1,15.2,32.8,19.8,33.4,17.3-22.7,17.3-22.7l-14.1-7.6-1.2-7.5-5.4-5.8-5.3-5.9-9.8-7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M146.2,380.3s8.3,25.6,10.8,28.9,11.6,7,14.6,7,17.2-17,17.2-26.3,1.2-18.5,1.2-18.5l-7.4.9-1.6,2.3s-18.6,8.9-26.2,8.9-8.6-3.4-8.6-3.4h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111.1 325.6 107.7 342.4 119.2 348.5 119.7 346.4 114.5 338 115.7 329.8 111.1 325.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M294.7,270.5s-2.2,28.4-6.2,32.4-18,1-18,1c0,0,4.7,8.4,3.8,12.2s-24-6.1-24-6.1c0,0,9.9,22.9,6.6,27.1s-31.4,26.7-31.4,26.7l-.9,4.8-4.9,10.5-7.4-4.4-23.5,12.5-5.6,22.2s27.5-10,31.8-13.7,55.2-40.4,58.4-45,29.2-35.6,29.1-38.4,8.9-17.6,6.7-23.2-14.5-18.5-14.5-18.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M198.3,335.5s-6.1-1.4-8.2,3.2c0,0,.6-12.4-1.8-13.6,0,0,6.5,6.7,10,10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M245.1,286.9s17-22.4,21.8-22,23.4,1.3,23.4,1.3l16,17.8-24.5,60.3s-18.6,7.2-19,7.9,2,51.8,2,51.8l23.6,4.3,1.8-57.7,16-35.9s10.8-28.6,4.8-41.8l-12.4-3.1-13.5-10.9h-26.2l-13.8,28h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hand_Lines-4",
    "data-name": "Hand Lines-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M130.4,167s19.1-1.1,23.8.6,18.1,18.9,20.5,24.3-7.1,93.8-8.8,95.5-23.3,4.4-23.3,4.4"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 134.6,
    cy: 210.2,
    r: 28.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.8,
    cy: 262.5,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M140.6,166s-3.2-13.5-5.2-15.7-6.8-1.5-6.8-1.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M130.4,167s-18.9,2.6-23.2,5.2-14.1,22.1-15.4,27.8,25.2,90.7,27.2,92,23.7-.2,23.7-.2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 134.6,
    cy: 210.2,
    r: 28.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 139.8,
    cy: 262.5,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M120.2,168s.6-13.8,2-16.4,6.4-2.8,6.4-2.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M156.8,290.9s1.2,20.7-3.4,23.3-8.4,2.8-8.4,2.8c0,0-3.7.6-8.7-1.1-5-1.7-7.8-22.2-7.8-22.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M131.5,361.5c-3.3.2-3,9.1-3,9.1,4.5,1.2,24.4,11.1,26.3,11.1s23.8-9,25.2-9.2,3.9-9.2,6-12.9.2-5.9.2-9,3.4-4.4,3.7-9.2c.3-4-2.6-5.3-3-9.6s1-7.6,0-9.7-3.4-6-6.9-7.1-18.1-1.4-20.5-1.4-17.2,5-19.8,6.5-11.4,5.4-13.5,8.8c0,0-.2,6.9,4.8,6.9s5.6-.4,5.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M176.7,362.4c-4.7.6-19.2,5.7-21,5.7s-26.9-7-29.4-9c0,0-1.2-7.8,4.1-8.3s22.8,3.2,25.3,2.5c3.6-1,18.3-5.5,18.3-5.5,0-1.9-13.5-1.9-17.1-1.7-6.3.3-26.8,4.6-27.9,4-2.7-1.6-3.4-7.2-2.8-8.9,1.2-3.4,27-11.3,29.5-12s17.8,2.8,20.5,1.8c2.5-1,3.9-1.2,3.9-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M129.1,316c4-1.1,2.9-7,2.9-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M156.8,290.9s7.4,4.3,9.5,5.1c0,0,10.4,9.3,11.4,11s-4.8,5.3-12.3,3-7.9-2.7-7.9-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M168.2,280s6.9,8,7.5,11.9.9,17.4,5.2,23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 161.9,
    y1: 289.6,
    x2: 161.9,
    y2: 292.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M160.5,309.5s-.8,2.5-4.8,3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M144.2,379s4.8,22.9,10.1,28.7c20.8,22.8,30.9-1.1,34.3-13,3.5-11.9,3.6-27.8.5-47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M111.1,322.6s-7.7,27.9-6.2,43.7c1.1,11.7,13.1,37.1,21.3,37.1s18-24.3,18-24.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M187.9,323.1s13.8,10.7,15.6,20.7,1.7,24.5,1.7,24.5l11.5,10.6,6.7-12.7s1.6-23.5-5.2-34.7-15.5-15.5-15.5-15.5l-17.1,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M290.4,266.2s-7.4-2.9-20.2,0-31,33.2-31,33.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M280.5,318s-14.2-21.2-23.6-21.2-23.6,4.1-23.6,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M261.4,313.1s-27.2-12.7-31.5-9.8-9.4,6.4-9.4,6.4l-15.3,6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M309.3,293s-2.2,15.8-6.8,21.6-27.2,36.5-31.8,39.6-56.2,43.5-63.6,46.1-32.4,16-32.4,16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.4,355c6.7,0,7.5,13.3,0,13.3s-6.8-13.3,0-13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M80.1,305.1c4.8-5.8,15.8-11.8,19-12s12,6,12,6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M123.3,293.6c-1.2,2.5-4.4,9.2-5.3,11.2-1.1,2.5-4.6,5-8,8.9s6.1,12.8,6.1,15.3-.4,6-.4,8.6,3.9,2.7,4,5.2-1.9,8.4-1.1,9.2,6.1,7.6,8.2,8.8,3.3,1.6,3.3,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M91.7,307.4c6.4-5.3,16.6-8.2,21.9-7.2,3.3.6,3.9.7,5.8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M107.9,300.9c-9.9,2.2-19.8,31.6-19.8,31.6l5.4,18,6.9-14.2s3.3-10.8,8.5-19.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.2,337.4c4.4,2,9.6-8.2,3.8-10.9s-9.9,8.2-3.8,10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M68.1,316s-3.5,22,0,26,13.8,8.9,16.8,15.5,27.4,35.4,35.6,42.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M106.9,344.1s6.9,1.2,11.1,6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 181.9,
    y1: 371,
    x2: 190,
    y2: 369.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M9.7,238.3s107.5-28.1,110.8-34.3c6-11.5-3.2-74.8-3.2-74.8,0,0,15.7,68.2,29,68.9s143.8-28.9,143.8-28.9c0,0-142.7,43.5-144.6,48.5-4.9,12.8,1.9,47.1,1.9,47.1,0,0-14.6-43-22.9-44-9-1.1-114.8,17.4-114.8,17.4h0Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 196.4,
    y1: 257.6,
    x2: 196.9,
    y2: 258.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalconreact2);
export default __webpack_public_path__ + "static/media/falcon react2.2e3968d2026bec3b675206c089cb572a.svg";
export { ForwardRef as ReactComponent };